export default "__VITE_ASSET__DDX4ihS2__"